import { Table } from 'antd';
import styles from './style.module.scss';

const MyTable = (props) => {
  return <Table className={styles.myTable} {...props} />;
};

export default MyTable;
